<template>
    <div class="sw-modal task-details">
        <div v-click-outside="close" v-on:click.stop class="sw-modal-content" v-bind:class="{'text-temporary': doesTaskBelongToCancelledBooking}">
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4>{{task.name}}</h4>
                    <h5>
                        <span v-html="taskIcon"></span>
                        {{taskType}}
                    </h5>
                </div>
            </div>
            <div class="sw-modal-body">
                <template v-if="errorMessage">
                    <div class="row">
                        <div class="col-12 infobar infobar-error">{{errorMessage}}</div>
                    </div>
                </template>

                <template v-else>
                    <template v-if="infoMessage">
                        <div class="row">
                            <div class="col-12 infobar infobar-info">{{infoMessage}}</div>
                        </div>
                    </template>

                    <div class="task-details__task hover-button-hover-container" v-on:mouseenter="showIncompleteButtonIfComplete" v-on:mouseleave="showIncompleteButton = false">
                        <div class="row sw-modal-sub-heading">
                            <div class="col-10">
                                <span class="icon-bullet"><i class="fas fa-calendar-alt"></i></span>
                                Task
                            </div>
                            <div class="col-2 text-right">
                                <button class="hover-button" v-on:click.stop="goToTask()">
                                    <i class="far fa-calendar-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5">
                                <span class="icon-bullet"><i class="far fa-clock"></i></span>
                                Scheduled:
                            </div>
                            <template v-if="isRescheduleAction">
                                <div class="col-7 text-left sw-modal-date">
<!--                                <div class="col-7 text-left sw-modal-date" v-on:click="hideCalendar">-->
                                    {{friendlyDateAndTime(task.scheduledDate)}}
<!--                                    <div v-if="!showCalendar" class="task-edit-button" v-on:click.stop="openCalendar">-->
<!--                                        <i class="fas fa-pencil-alt"></i>-->
<!--                                    </div>-->
                                    <div class="task-actions">
                                        <button v-if="isTaskPaused && task.canUnpause" v-on:click.stop="unpause" class="btn btn-normal">
                                            <i class="fas fa-play"></i> Un-pause
                                        </button>
                                        <button v-if="isTaskScheduled" v-on:click.stop="pause" class="btn btn-normal">
                                            <i class="fas fa-pause"></i> Pause
                                        </button>
                                        <button v-on:click.stop="openCalendar" class="btn btn-normal">
                                            <i class="far fa-clock"></i> Reschedule
                                        </button>
                                        <button v-if="isTaskScheduled" v-on:click.stop="confirmCancelAction" class="btn btn-normal">
                                            <i class="fas fa-trash-alt"></i> Cancel Task
                                        </button>
                                    </div>
                                    <edit-date v-if="showCalendar"
                                               title="Scheduled Date"
                                               v-bind:date="task.scheduledDate"
                                               v-bind:ownerReference="task.reference"
                                               v-bind:updating="updating"
                                               v-bind:error="error"
                                               v-bind:success="success"
                                               v-bind:infoMessage="infoMessage"
                                               v-click-outside.stop="hideCalendar">
                                    </edit-date>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-7 text-left sw-modal-date">
                                    {{friendlyDateAndTime(task.scheduledDate)}}
                                </div>
                            </template>
                        </div>
                        <div class="row" v-if="showExecutedDate && isFormTask">
                            <div class="col-5">
                                <span class="icon-bullet"><i class="fab fa-wpforms"></i></span>
                                Created:
                            </div>
                            <div class="col-7 text-left sw-modal-date">
                                <template v-if="task.executedDate">
                                    {{friendlyDateAndTime(task.executedDate)}}
                                </template>
                                <template v-else>
                                    <span class="text-error">
                                        Not created
                                    </span>
                                </template>
                            </div>
                        </div>
                        <div class="row" v-if="showExecutedDate && (isSendEmailAction || isSendSMSAction)">
                            <div class="col-5">
                                <template v-if="isSendEmailAction">
                                    <span class="icon-bullet"><i class="fas fa-envelope"></i></span>
                                </template>
                                <template v-else="">
                                    <span class="icon-bullet"><i class="fas fa-sms"></i></span>
                                </template>
                                Sent:
                            </div>
                            <div class="col-7 text-left sw-modal-date">
                                <template v-if="task.executedDate">
                                    {{friendlyDateAndTime(task.executedDate)}}
                                    <div v-if="canResend" class="tooltip-container d-inline-block">
                                        <button class="hover-button" v-on:click.stop="resend">
                                            <i class="fas fa-paper-plane" v-on:mouseenter="showResendTooltip = true" v-on:mouseleave="showResendTooltip = false" aria-hidden="true"></i>
                                        </button>
                                        <tooltip v-bind:visible="showResendTooltip" v-bind:position="'bottom'" v-bind:text="'Resend email'"></tooltip>
                                    </div>
                                </template>
                                <template v-else>
                                    <span class="text-error">
                                        Not sent
                                    </span>
                                </template>
                            </div>
                        </div>
                        <div class="row" v-if="showLastResentDate && (isSendEmailAction || isSendSMSAction)">
                            <div class="col-5">
                                <template v-if="isSendEmailAction">
                                    <span class="icon-bullet"><i class="fas fa-envelope"></i></span>
                                </template>
                                <template v-else="">
                                    <span class="icon-bullet"><i class="fas fa-sms"></i></span>
                                </template>
                                Last resent:
                            </div>
                            <div class="col-7 text-left sw-modal-date">
                                <span v-bind:class="{'text-success' : resentNow}">{{friendlyDateAndTime(lastResentDate)}}</span>
                            </div>
                        </div>
                        <div class="row" v-if="task.dueDate">
                            <div class="col-5">
                                <span class="icon-bullet"><i class="far fa-clock"></i></span>
                                Due:
                            </div>
                            <div class="col-7 text-left sw-modal-date">
                                <span v-bind:class="{'text-error' : task.overdue}">{{friendlyDateAndTime(task.dueDate)}}</span>
                            </div>
                        </div>
                        <div class="row" v-if="showCompletedDate">
                            <div class="col-5">
                                <span v-if="showIncompleteButton" class="icon-bullet">
                                    <button class="hover-button hover-button--replacing-icon" v-on:click.stop="confirmMarkIncompleteAction">
                                        <i class="fas fa-undo-alt" v-bind:class="actionIcon" v-on:mouseenter="showMarkIncompleteTooltip = true" v-on:mouseleave="showMarkIncompleteTooltip = false" aria-hidden="true"></i>
                                    </button>
                                    <tooltip v-bind:visible="showMarkIncompleteTooltip" v-bind:position="'bottom'" v-bind:text="'Change to incomplete'"></tooltip>
                                </span>
                                <span v-else class="icon-bullet">
                                    <i class="fas fa-check"></i>
                                </span>
                                {{completedLabel}}:
                            </div>
                            <div class="col-7 text-left sw-modal-date">
                                <template v-if="isComplete">
                                    {{friendlyDateAndTime(task.completedDate)}}
                                </template>
                                <template v-else-if="isInProgress">
                                    <span v-bind:class="{'text-error' : task.overdue}">In progress</span>
                                </template>
                                <template v-else>
                                    <span v-bind:class="{'text-error' : task.overdue}">No</span>
                                </template>

                                <template v-if="isFormTask && !isTaskBookingCancelled">
                                    <div class="tooltip-container d-inline-block">
                                        <button class="hover-button" v-on:click.stop="openFormResponse">
                                            <i class="fas" v-bind:class="actionIcon" v-on:mouseenter="showTooltip = true" v-on:mouseleave="showTooltip = false" aria-hidden="true"></i>
                                        </button>
                                        <tooltip v-bind:visible="showTooltip" v-bind:position="'bottom'" v-bind:text="actionTooltip"></tooltip>
                                    </div>
                                </template>
                                <template v-else-if="!isComplete">
                                    <template v-if="isMarkDoneAction">
                                        <div class="tooltip-container d-inline-block">
                                            <button class="hover-button" v-on:click.stop="markComplete">
                                                <i class="fas" v-bind:class="actionIcon" v-on:mouseenter="showTooltip = true" v-on:mouseleave="showTooltip = false" aria-hidden="true"></i>
                                            </button>
                                            <tooltip v-bind:visible="showTooltip" v-bind:position="'bottom'" v-bind:text="actionTooltip"></tooltip>
                                        </div>
                                        <div class="tooltip-container d-inline-block">
                                            <button class="hover-button" v-on:click.stop="confirmCancelAction">
                                                <i class="fas fa-times" v-on:mouseenter="showTooltipDelete = true" v-on:mouseleave="showTooltipDelete = false" aria-hidden="true"></i>
                                            </button>
                                            <tooltip v-bind:visible="showTooltipDelete" v-bind:position="'bottom'" v-bind:text="'Delete'"></tooltip>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col"><hr/></div>
                    </div>

                    <template v-if="task.booking">
                        <div  class="task-details__booking hover-button-hover-container">
                            <div class="row sw-modal-sub-heading">
                                <div class="col-10">
                                    <span class="icon-bullet"><i class="fas fa-bed"></i></span>
                                    Booking
                                </div>
                                <div class="col-2 text-right">
                                    <button class="hover-button" v-on:click.stop="openBooking()">
                                        <i class="fas fa-bed"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <span class="icon-bullet"><i class="fas fa-user"></i></span>
                                    Guest:
                                </div>
                                <div class="col-7"><guest-name v-bind:guest="task.booking.bookedBy" v-bind:highlightIfMissing="true"></guest-name></div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <span class="icon-bullet"><i class="fas fa-door-open"></i></span>
                                    Arrive:
                                </div>
                                <div class="col-7 text-left sw-modal-date">{{friendlyDate(task.booking.arrival)}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <span class="icon-bullet"><i class="fas fa-door-closed"></i></span>
                                    Depart:
                                </div>
                                <div class="col-7 text-left sw-modal-date">{{friendlyDate(task.booking.departure)}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <span class="icon-bullet"><i class="far fa-clock"></i></span>
                                    Booked:
                                </div>
                                <div class="col-7 text-left sw-modal-date">{{friendlyDateAndTime(task.booking.dateBooked)}}</div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>
                    </template>

                    <div class="row sw-modal-sub-heading">
                        <div class="col-2 text-center"><i class="fas fa-history"></i></div>
                        <div class="col-8 sw-modal-sub-heading">
                            History
                            <span class="text-note">({{history.length}} entries)</span>
                        </div>
                        <div class="col-2 text-right">
                            <i class="fa fa-chevron-down" v-show="!historyExpanded" v-on:click.stop="toggleHistory"></i>
                            <i class="fa fa-chevron-up" v-show="historyExpanded" v-on:click.stop="toggleHistory"></i>
                        </div>
                    </div>
                    <div class="row" v-if="loading">
                        <div class="col-12 text-center">
                            Fetching history
                            <Spinner/>
                        </div>
                    </div>
                    <template v-else>
                        <div v-if="historyErrorMessage" class="row">
                            <div class="col-12 infobar infobar-error">{{historyErrorMessage}}</div>
                        </div>
                        <div v-else v-show="historyExpanded" class="row">
                            <div class="col-12">
                                <ul class="history__log">
                                    <li v-for="(logEntry, index) in history.slice().reverse()" v-bind:key="index">
                                        <div class="history__log__meta">
                                            <span>{{friendlyDateAndTime(logEntry.created)}}</span>
                                        </div>
                                        <div class="history__log__details">
                                            <div class="history__log__details__type">{{logEntry.type}}</div>
                                            <div v-if="logEntry.detail" v-bind:inner-html.prop="logEntry.detail | marked"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                    
                </template>
            </div>
        </div>

        <confirm-dialog message="Are you sure you want to cancel this Task?"
                        v-bind:callbackPrimaryName="'cancel-task'"
                        v-bind:callbackPrimaryReference="task.reference"
                        v-if="showConfirmCancelDialog"/>

        <confirm-dialog message="Are you sure you want to change this Task from <b>complete</b> to <b>incomplete</b>?"
                        v-bind:callbackPrimaryName="'mark-incomplete'"
                        v-bind:callbackPrimaryReference="task.reference"
                        v-if="showConfirmMarkIncompleteDialog"/>
    </div>
</template>

<script>
    // import Vue from 'vue';

    import * as dayjs from 'dayjs'

    import { store } from '../../store.js'

    import Spinner from '../Spinner.vue'
    import Tooltip from '../Tooltip'
    import EditDate from '../EditDate.vue'
    import ConfirmDialog from '../ConfirmDialog.vue'
    import GuestName from '../GuestName'

    import { datesMixin } from "../../mixins/DatesMixin"
    import { tasksMixin } from "../../mixins/TasksMixin"

    export default {
        name: 'TaskDetails',
        components: {
            Spinner, Tooltip, EditDate, ConfirmDialog, GuestName
        },
        mixins: [datesMixin, tasksMixin],
        props: {
            task: Object
        },
        data: function () {
            return {
                loading: true,
                errorMessage: null,
                historyErrorMessage: null,
                history: [],
                showIncompleteButton: false,
                showTooltip: false,
                showMarkIncompleteTooltip: false,
                showResendTooltip: false,
                showTooltipDelete: false,
                showCalendar: false,
                historyExpanded: false,
                updating: false,
                resentNow: false,
                success: false,
                error: false,
                infoMessage: "",
                showConfirmCancelDialog: false,
                showConfirmMarkIncompleteDialog: false
            }
        },
        computed: {
            doesTaskBelongToCancelledBooking: function() {
                return this.task.booking && this.isBookingCancelled(this.task.booking)
            },
            actionIcon: function () {
                switch (String(this.task.type)) {
                    case 'guest-form':
                    case 'omni-channel-form':
                        if (this.isComplete) {
                            return 'fa-eye task-done'
                        } else {
                            return 'fa-edit'
                        }
                    case 'check-in':
                    case 'check-out':
                    case 'todo':
                        return 'fa-check task-done'
                }
                return '';
            },
            actionTooltip: function () {
                switch (String(this.task.type)) {
                    case 'check-in':
                        return 'Check in';
                    case 'check-out':
                        return 'Check out';
                    case 'guest-form':
                    case 'omni-channel-form':
                        if (this.isComplete) {
                            return 'View'
                        } else {
                            return 'Edit'
                        }
                    case 'todo':
                        if (!this.isComplete) {
                            return 'Mark as done'
                        }
                        break;
                }
                return '';
            },
            showExecutedDate: function () {
                switch (String(this.task.type)) {
                    case 'email':
                    case 'sms':
                    case 'guest-form':
                    case 'omni-channel-form':
                        return this.task.executedDate || !this.isRescheduleAction;
                    default:
                        return false;
                }
            },
            showLastResentDate: function() {
                if (this.loading) {
                    return false;
                }
                return this.history.filter(le => le.type === 'notified').length > 1;
            },
            lastResentDate: function() {
                return this.history.filter(le => le.type === 'notified').reverse()[0].created;
            },
            isInProgress: function() {
                return this.task.state === 'DOING';
            },
            isComplete: function() {
                if (this.task.completedDate) {
                    return true;
                }
                return false;
            },
            showCompletedDate: function() {
                switch (String(this.task.type)) {
                    case 'check-in':
                    case 'check-out':
                    case 'guest-form':
                    case 'omni-channel-form':
                    case 'todo':
                        return this.task.completedDate || !this.isRescheduleAction;
                    default:
                        return false;
                }
            },
            completedLabel: function() {
                switch (String(this.task.type)) {
                    case 'check-in':
                        return 'Checked In';
                    case 'check-out':
                        return 'Checked Out';
                    case 'guest-form':
                    case 'omni-channel-form':
                        return 'Completed';
                    case 'todo':
                        return 'Done';
                    default:
                        return '';
                }
            }
        },
        methods: {
            showIncompleteButtonIfComplete: function() {
                if (this.isComplete) {
                    this.showIncompleteButton = true
                }
            },
            toggleHistory: function () {
                this.historyExpanded = !this.historyExpanded
            },
            loadTaskHistory: function() {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/tasks/' + this.task.reference + "/history", {
                    withCredentials: true
                }).then(response => {
                    if (response.data) {
                        this.history.splice(0, this.history.length);
                        this.history.push(...response.data);
                    }
                }).catch(error => {
                    console.log(error);
                    this.historyErrorMessage = "Error loading history: " + error.response.data.message;
                }).finally(() => {
                    this.loading = false
                })
            },
            pause: async function() {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/' + this.task.reference + '/pause';

                this.infoMessage = "Pausing";
                this.updating = true;
                this.error = false;
                this.success = false;

                try {
                    const response = await this.$http.put(url);
                    console.log("Task paused");
                    console.log(response);
                    this.infoMessage = "Task paused";
                    this.$root.$emit('task-updated', response.data);
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    setTimeout(() => {
                        this.infoMessage = "";
                        this.success = false;
                    }, 2000);
                } catch (error) {
                    this.error = true;
                    this.success = false;
                    this.updating = false;
                    this.errorMessage = "Error pausing task";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                }
            },
            unpause: async function() {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/' + this.task.reference + '/unpause';

                this.infoMessage = "Unpausing";
                this.updating = true;
                this.error = false;
                this.success = false;

                try {
                    const response = await this.$http.put(url);
                    console.log("Task unpaused");
                    console.log(response);
                    this.infoMessage = "Task unpaused";
                    this.$root.$emit('task-updated', response.data);
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    setTimeout(() => {
                        this.infoMessage = "";
                        this.success = false;
                    }, 2000);
                } catch (error) {
                    this.error = true;
                    this.success = false;
                    this.updating = false;
                    this.errorMessage = "Error pausing task";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                }
            },
            formatDate: function(date) {
                return dayjs(date).format("D MMM @ HH:mm");
            },
            openCalendar: function() {
                this.showCalendar = true;
            },
            hideCalendar: function() {
                console.debug("Closing calendar");
                this.showCalendar = false;
            },
            reschedule: function(ownerReference, date) {
                if (ownerReference === this.task.reference) {
                    console.log("Updating to: " + date);

                    let body = {
                        "reference": this.task.reference,
                        "scheduledDate": date
                    };

                    let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                        + '/tasks/' + this.task.reference + '/reschedule';

                    this.infoMessage = "Rescheduling";
                    this.updating = true;
                    this.error = false;
                    this.success = false;

                    this.$http.put(url, body
                    ).then(response => {
                        console.log("Task rescheduled:")
                        console.log(response);
                        let oldDay = dayjs(this.task.scheduledDate).startOf("day").toDate();
                        this.infoMessage = "Task rescheduled";
                        this.$root.$emit('task-updated', response.data);
                        this.showCalendar = false;
                        this.updating = false;
                        this.error = false;
                        this.success = true;
                        setTimeout(() => {
                            this.infoMessage = "";
                            this.success = false;
                            this.$root.$emit('task-rescheduled', oldDay, this.task);
                        }, 2000);
                    }).catch(error => {
                        this.error = true;
                        this.success = false;
                        this.updating = false;
                        this.errorMessage = "Error rescheduling task";
                        if (error.response) {
                            this.errorMessage += ": " + error.response.data.message
                        }
                    });
                }
            },
            confirmCancelAction: function() {
                this.showConfirmCancelDialog = true;
            },
            cancel: function(taskReference) {
                this.showConfirmCancelDialog = false;
                if (!taskReference || taskReference !== this.task.reference) {
                    return;
                }

                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/' + this.task.reference + '/cancel';

                this.infoMessage = "Cancelling";
                this.updating = true;
                this.error = false;
                this.success = false;

                this.$http.put(url
                ).then(response => {
                    this.infoMessage = "This Task has been cancelled";
                    this.$root.$emit('task-updated', response.data);
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    setTimeout(() => {
                        this.success = false;
                        this.close();
                    }, 5000);
                }).catch(error => {
                    this.updating = false;
                    this.error = true;
                    this.success = false;
                    this.errorMessage = "Error cancelling task";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                    setTimeout(() => {
                        this.infoMessage = null;
                        this.error = false;
                    }, 5000);
                });
            },
            resend: function() {
                console.log("Resending email");

                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/' + this.task.reference + '/resend';

                this.infoMessage = "Resending email";
                this.updating = true;
                this.error = false;
                this.success = false;

                this.$http.post(url
                ).then(() => {
                    console.log("Email sent")
                    this.infoMessage = "Email sent";
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    this.resentNow = true;
                    setTimeout(() => {
                        this.infoMessage = "";
                        this.success = false;
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.success = false;
                    this.updating = false;
                    this.errorMessage = "Error resending email";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                });
            },
            confirmMarkIncompleteAction: function() {
                this.showConfirmMarkIncompleteDialog = true;
            },
            markIncomplete: function(taskReference) {
                this.showConfirmMarkIncompleteDialog = false;
                if (!taskReference || taskReference !== this.task.reference) {
                    return;
                }

                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/' + this.task.reference + '/incomplete';

                this.infoMessage = "Changing to incomplete";
                this.updating = true;
                this.error = false;
                this.success = false;

                this.$http.put(url
                ).then(() => {
                    console.log("Marked incomplete")
                    this.infoMessage = "Task incomplete";
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    setTimeout(() => {
                        this.infoMessage = "";
                        this.success = false;
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.success = false;
                    this.updating = false;
                    this.errorMessage = "Error changing to incomplete";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                });
            },
            openFormResponse: function () {
                if (this.task.formResponseReference) {
                    this.$router.push({name: 'ViewForm', params: {reference: this.task.formResponseReference}})
                    this.close();
                }
            },
            openBooking: function() {
                console.log("opening booking");
                this.$root.$emit('open-trip-details', this.task.booking);
                this.close();
            },
            markComplete: function () {
                console.log("Marking as complete");

                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/tasks/todos/' + this.task.reference + '/complete';

                this.infoMessage = "Marking as complete";
                this.updating = true;
                this.error = false;
                this.success = false;

                this.$http.put(url
                ).then(response => {
                    console.log("Task complete:")
                    console.log(response);
                    this.infoMessage = "Task complete";
                    this.$root.$emit('task-updated', response.data);
                    this.updating = false;
                    this.error = false;
                    this.success = true;
                    setTimeout(() => {
                        this.infoMessage = "";
                        this.success = false;
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.success = false;
                    this.updating = false;
                    this.errorMessage = "Error marking task as complete";
                    if (error.response) {
                        this.errorMessage += ": " + error.response.data.message
                    }
                });
            },
            taskUpdated: function() {
                console.log("Notified that this task changed");
                this.loadTaskHistory();
            },
            goToTask: function() {
                const jump = dayjs(this.task.scheduledDate);
                console.log("Jumping to date: " + jump);
                this.$router.push({name: 'JumpToDateOnTaskCalendar',
                    params: {
                        year: jump.format("YYYY"),
                        month: jump.format("M"),
                        day: jump.format("D"),
                    }
                });
                this.close();
            },
            close: function () {
                console.log("close task");
                this.$root.$emit('finished-viewing-task-details');
            },
        },
        mounted() {
            this.loadTaskHistory();

            this.$root.$on('save-edit-date', this.reschedule);
            this.$root.$on('close-edit-date', this.hideCalendar);
            this.$root.$on('cancel-task', this.cancel);
            this.$root.$on('mark-incomplete', this.markIncomplete);
            this.$root.$on('task-updated', this.taskUpdated);
        },
        beforeDestroy () {
            this.$root.$off('save-edit-date', this.reschedule);
            this.$root.$off('close-edit-date', this.hideCalendar);
            this.$root.$off('cancel-task', this.cancel);
            this.$root.$off('mark-incomplete', this.markIncomplete);
            this.$root.$off('task-updated', this.taskUpdated);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/task";
    @import "../../styles/components/task_details";
</style>